/**
 * @file
 * @prettier
 */

export class CurrentPaymentInstructionsControl {
  public saveChanges: boolean = false;

  constructor() {
    const me = this;

    // review dialog box
    $("[id$='divCancelInstructionsDialog']").dialog({
      autoOpen: false,
      modal: true,
      resizable: false,
      title: "CONFIRMATION",
      width: 250,
      buttons: [
        {
          text: "YES",
          class: "twoColorButton",
          click: function () {
            me.saveChanges = true;
            $("[id$='btnCancelCurrentInstruction']").click();
          },
        },
        {
          text: "NO",
          class: "secondaryButton",
          click: function () {
            me.saveChanges = false;
            $(this).dialog("close");
          },
        },
      ],
    });

    $("[id$='btnCancelCurrentInstruction']").on("click", (e) => {
      if (me.saveChanges) {
        me.saveChanges = false;
        return true;
      }
      e.preventDefault();
      $("[id$='divCancelInstructionsDialog']").dialog("open");
      return false;
    });
  }
}
